import React, {useEffect} from "react"
import {ReactFlow, MiniMap, MarkerType, useNodesState, useEdgesState} from "@xyflow/react"
import "@xyflow/react/dist/style.css"
import {useSelector} from "react-redux"
import Section from "./Section"
import Step from "./Step"
import Parse from "parse"

const COLORS = ["#00A2E8", "#D308F5", "#F50C6C", "#08F57B"]
let colorIndex = 0
const getNextColor = () => {
    const color = COLORS[colorIndex]
    colorIndex = (colorIndex + 1) % COLORS.length
    return color
}

const SECTION_HEIGHT = 50
const STEP_INDENT = 100
const STEP_WIDTH = 300
const STEP_HEIGHT = 50
const MARGIN_TOP = 10
const STEP_MARGIN_LEFT = 60

export default function Flow({recipeId}) {
    let recipeInStore = useSelector(state => state.flow.recipe)
    const [recipe, setRecipe] = React.useState(recipeInStore.get ? recipeInStore : null)


    useEffect(() => {
        const load = async () => {
            const recipe = await new Parse.Query("Recipe")
                .equalTo("objectId", recipeId)
                .include("sections", "sections.productionSteps.step")
                .select("sections", "sections.name", "sections.productionSteps", "sections.productionSteps.step")
                .first()
            setRecipe(recipe)
        }
        if (recipeId) {
            load()
        }
    }, [recipeId])


    const [nodes, setNodes /*, onNodesChange*/] = useNodesState([])
    const [edges, setEdges /*, onEdgesChange*/] = useEdgesState([])

    useEffect(() => {
        if (!recipe) {
            return
        }
        const nodes = []
        const edges = []
        let currentSectionY = 0
        recipe.get("sections").forEach(section => {
            //--------------------------------//
            //------------ Section -----------//
            //--------------------------------//
            const sectionColor = getNextColor()
            const size = {width: 300, height: SECTION_HEIGHT}
            const sectionNode = {
                id: section.id,
                type: "section",
                data: {
                    label: section.get("name"),
                    size,
                    color: sectionColor,
                    id: section.id
                },
                position: {x: 0, y: currentSectionY},
                measured: size,
            }
            nodes.push(sectionNode)
            currentSectionY += SECTION_HEIGHT + MARGIN_TOP

            //--------------------------------//
            //------------- Steps ------------//
            //--------------------------------//
            const currentYByLevel = new Map()
            const stepsDataByIndex = new Map()
            section.get("productionSteps").forEach(productionStep => {
                const step = productionStep.step

                //---- priorStep and level ----//
                let level = 0
                const stepComponentWithPriorStep = step.get("stepComponents")?.find(stepComponent => stepComponent.priorSteps)
                const priorStepIndex = stepComponentWithPriorStep?.priorSteps.index
                let priorStepData
                if (priorStepIndex) {
                    priorStepData = stepsDataByIndex.get(priorStepIndex)
                    // if (priorStepData) {
                    // 	level = priorStepData.level + 1
                    // }
                    if (!priorStepData) {
                        throw Error("Prior step with index " + priorStepIndex + " not found!")
                    }
                    level = priorStepData.level + 1
                }

                //---- stepsDataByIndex ----//
                const stepIndex = step.get("index")
                stepsDataByIndex.set(stepIndex, {
                    id: step.id,
                    level
                })

                //---- currentLevelY ----//
                let currentLevelY = currentYByLevel.get(level)
                if (!currentLevelY) {
                    currentLevelY = currentSectionY
                    currentYByLevel.set(level, currentLevelY)
                }

                //---- stepNode ----//
                const size = {width: STEP_WIDTH, height: STEP_HEIGHT}
                const stepNode = {
                    id: step.id,
                    type: "step",
                    data: {
                        label: step.get("name"),
                        size,
                        id: step.id,
                        level,
                        color: sectionColor,
                    },
                    position: {x: STEP_INDENT + level * (STEP_WIDTH + STEP_MARGIN_LEFT), y: currentLevelY},
                    measured: size
                }
                nodes.push(stepNode)

                //---- edge to priorStep ----//
                if (priorStepData) {
                    const edge = {
                        id: priorStepData.id + "-" + step.id,
                        source: priorStepData.id,
                        sourceHandle: "right",
                        target: step.id,
                        targetHandle: "left",
                        animated: true,
                        markerEnd: {
                            type: MarkerType.ArrowClosed,
                        },
                    }
                    edges.push(edge)
                }

                currentYByLevel.set(level, currentLevelY + STEP_HEIGHT + MARGIN_TOP)
            })
            // the next section starts after the tallest level column
            currentSectionY = Math.max(...currentYByLevel.values())
        })

        setNodes(nodes)
        setEdges(edges)
    }, [recipe])

    const nodeTypes = {
        section: Section,
        step: Step
    }

    return (
        <div className="flexColumn stretch flex1">
            <h1>Flow de la recette</h1>
            <ReactFlow
                nodes={nodes}
                //onNodesChange={onNodesChange}
                edges={edges}
                nodeTypes={nodeTypes}
            >
                <MiniMap zoomable pannable/>
            </ReactFlow>
        </div>
    )
}

